import React from 'react';
import { TableRow, TableCell, Skeleton, Box } from '@mui/material';

const DateRowSkeletonMe = () => {
  return (
    <TableRow sx={{ backgroundColor: '#fff', borderRadius: '10px' }}>
      <TableCell sx={{ padding: '10px 16px' }}>
        <Skeleton variant="circular" width={18} height={18} />
      </TableCell>
      <TableCell sx={{ padding: '10px 16px', textAlign: 'center' }}>
        <Skeleton variant="text" width={20} height={20} />
      </TableCell>
       <TableCell sx={{ border: 'none' }}>
            <Box display="flex" alignItems="center" gap={1}>
              <Skeleton variant="circular" width={40} height={40} />
              <Box>
                <Skeleton width={100} height={20} />
                <Skeleton width={80} height={16} />
              </Box>
            </Box>
          </TableCell> 
      <TableCell sx={{ padding: '10px 16px' }}>
        <Skeleton variant="text" width="70%" />
      </TableCell>
      <TableCell sx={{ padding: '10px 16px', textAlign: 'center' }}>
        <Skeleton variant="text" width="40%" />
      </TableCell>
      <TableCell sx={{ padding: '10px 16px', textAlign: 'center' }}>
        <Skeleton variant="text" width="50%" />
      </TableCell>
      <TableCell sx={{ padding: '10px 16px', textAlign: 'center' }}>
        <Skeleton variant="rectangular" width={60} height={20} />
      </TableCell>
    </TableRow>
  );
};

export default DateRowSkeletonMe;
